import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable, { Styles } from 'jspdf-autotable';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  constructor() {}

  printPdf(
    data: any[],
    coulumns: string[],
    title: string = 'Document',
    fileName: string = 'Document',
    orientation: 'p' | 'l' = 'l',
    format: 'a4' | 'a3' | 'a5' = 'a4',
    compress: boolean = true,
    cellStyles: {
      [key: string]: Partial<Styles>;
  } | undefined,
    fontName?: string,
  ): void {

    const pageOrinetation = orientation === 'l' ? 'landscape' : 'portrait';
    const doc = new jsPDF({
      orientation: pageOrinetation,
      compress: compress,
      format: format,
      unit: 'cm',
      precision: 3
    });

    const pageWidth = doc.internal.pageSize.width;

    // Header

    // const headerWidth = doc.getTextWidth(title);

    // const xPosition = (pageWidth - headerWidth) / 2;

    // doc.setFont(fontName, 'normal', 'bold');
    // doc.setFontSize(16);
    // doc.text(title, xPosition, 1);

    // Define rows based on data and column

    // const rows: any = data.map((rowData) => {
    //   console.log(rowData)

    // });
    // console.log(rows, "from service")
    // Calculate columnwidth

    const columnCount = coulumns.length;
    const columnwidth = (pageWidth - 1) / columnCount;

    // Define column styles dynamically

    // const columnStyles: any = {};
    // for (let i = 0; i < columnCount; i++) {
    //   columnStyles[i] = { cellWidth: columnwidth };
    // }

    // Add table to doc

    autoTable(doc, {
      head: [coulumns],
      body: data,
      margin: { top: 2, bottom: 1, left: 0.5, right: 0.5 },
      styles: {
        cellPadding: 0.125,
        valign: 'middle',
        halign: 'left',
        textColor: 50,
        lineWidth: 0.025,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [0, 102, 204],
        textColor: [255, 255, 255],
        fontSize: 10,
        fontStyle: 'bold',
        halign: 'center',
      },
      alternateRowStyles: {
        fillColor: [211, 211, 211],
      },
      theme: 'grid',
      columnStyles: cellStyles,
      didDrawPage: () => this.addHeaderToPdf(doc, title)  // Use the dynamically generated column styles
    });

    // Add footer with page number

    this.addFooterToPdf(doc);

    // Save the pdf

    doc.save(`${fileName}.pdf`);
  }

  private addFooterToPdf(doc: jsPDF) {
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const pageStr = `Page ${i} of ${pageCount}`;
      doc.setFontSize(10);
      doc.text(pageStr, pageWidth / 2, pageHeight - 0.5, { align: 'center' });
    }
  }

  private addHeaderToPdf(doc: jsPDF, title: string) {
    const pageWidth = doc.internal.pageSize.width;
    const headerWidth = doc.getTextWidth(title);
    const xPosition = (pageWidth - headerWidth) / 2;
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(16);
    doc.text(title, xPosition, 1);
  }

  printExcel(
    data: any[],
    sheetName: string ='Sheet1',
    fileName: string = 'ExportedData'
  ): void{

    const workSheet : XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    const workBook : XLSX.WorkBook = {
      Sheets : {[sheetName]: workSheet},
      SheetNames: [sheetName]
    }

    fileName = `${fileName}.xlsx`

    XLSX.writeFile(workBook,fileName);
  }

}
